module.exports = __webpack_public_path__ + "static/media/emily-swank-signature.11c7fab2.png";